import { useEffect, useState } from 'react';

export interface IDragAndDropResult {
  isDragging: boolean;
}

const useDragAndDrop = (): IDragAndDropResult => {
  const [isDragging, setIsDragging] = useState(false);

  useEffect(() => {
    const setMouseEvent = (event: MouseEvent) => {
      setIsDragging(event.type === 'mousedown');
    };

    window.addEventListener('mouseup', setMouseEvent);
    window.addEventListener('mousedown', setMouseEvent);

    return () => {
      window.removeEventListener('mouseup', setMouseEvent);
      window.removeEventListener('mousedown', setMouseEvent);
    };
  }, []);

  return {
    isDragging,
  };
};

export default useDragAndDrop;
